import I18N from '@leverege/i18n'
import React from 'react'

import Analytics from './Analytics'
import AnalyticsModel from './AnalyticsModel'

const id = 'ps.dataViewers.AnalyticsSupportDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.AnalyticsSupport',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : 'none',
  matches : { type : 'GroupDataViewer', objectType : 'station' },
  createSettings : ( props ) => {
    return AnalyticsModel.create()
  },
  render : ( props ) => {
    return React.createElement( Analytics, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
